export function authHeaders(token: string) {
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
}
